import React from 'react'

import { stepStatuses } from '../../constants'

import {
  APPLY_DATA_PATH,
  APPLY_ACTIVITY_PATH,
  APPLY_FINANCIAL_PATH
} from '../../../MainRoutes/constants'

import StepNav from '../../../../components/StepNav/StepNav'
import RouteStepNav from '../../../RouteStepNav/RouteStepNav'

function ProjectStepNav() {
  return (
    <StepNav>
      <RouteStepNav
        path={APPLY_DATA_PATH}
        step={stepStatuses.DATA}
      >
        Datos de la organización
      </RouteStepNav>
      <RouteStepNav
        path={APPLY_ACTIVITY_PATH}
        step={stepStatuses.ACTIVITY}
      >
        Actividad de la organización
      </RouteStepNav>
      <RouteStepNav
        path={APPLY_FINANCIAL_PATH}
        step={stepStatuses.FINANCIAL}
      >
        Estado de tus finanzas
      </RouteStepNav>
    </StepNav>
  )
}

export default ProjectStepNav
